<nav class="navbar navbar-expand-lg row mx-0" [ngStyle]="navStyles" [ngClass]="classes">
  <span class="navbar-brand col-10 col-md-auto mr-0">
      <img [src]="organization.logoUrl" class="d-inline-block align-center orgLogo">
      <span [innerHTML]="organization.name"></span>
  </span>
  
  <ng-container *ngIf="eventPageData.menu.length > 0">
    <div class=" col-2 col-md-auto text-right px-0">
      <button (click)="toggleNavbar()" class="navbar-toggler" type="button">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>

    <div #navbarNav class="collapse navbar-collapse justify-content-end">
      <div class="navbar-nav">
        <ng-container *ngFor="let menuItem of eventPageData.menu; let idx = index;">

          <ng-container *ngIf="(idx < 5) && innerWidth > 992">
            <a
              [ngStyle]="navRegularLinkStyles"
              class="nav-item nav-link"
              [href]="menuItem.href" [innerHTML]="menuItem.name">
              <span class="sr-only">(current)</span>
            </a>
          </ng-container>

          <ng-container *ngIf="innerWidth < 992">
            <a
              [ngStyle]="navRegularLinkStyles"
              class="nav-item nav-link"
              [href]="menuItem.href" [innerHTML]="menuItem.name">
              <span class="sr-only">(current)</span>
            </a>
          </ng-container>
        </ng-container>

        <div mdbDropdown class="dropdown" *ngIf="eventPageData.menu.length > 5 && innerWidth > 992" >
          <button
            class="btn btn-light--paybee-dropdawn dropdown-toggle dropdown-toggle--paybee"
            type="button"
            id="dropdownMenuButton"
            aria-expanded="false"
            mdbDropdownToggle
          >
            More
          </button>
          <ul mdbDropdownMenu
              class="dropdown-menu dropdown-menu-end dropdown-menu--paybee mdb-dropdown-menu--paybee"
              aria-labelledby="dropdownMenuButton"
              >
            <ng-container *ngFor="let menuItem of eventPageData.menu let idx = index;">
              <ng-container *ngIf="(idx >= 5)">
                <li class="dropdown-item--event-page"> 
                  <a class="dropdown-item" style="text-wrap: wrap;" [href]="menuItem.href" [innerHTML]="menuItem.name">
                        <span class="sr-only">(current)</span>
                    </a>
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>
</nav>